import { render, staticRenderFns } from "./AddModele.vue?vue&type=template&id=2ae64962&"
import script from "./AddModele.vue?vue&type=script&lang=js&"
export * from "./AddModele.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports